export function navigationValidationRules(
    workspaceLocalStorage: string,
    organizationLocalStorage: string,
    nameOrg: string
) {
  if(workspaceLocalStorage != "" && workspaceLocalStorage != null && organizationLocalStorage == nameOrg)
    return `/${organizationLocalStorage}/${workspaceLocalStorage}/validationRule`;
  else
    return `/${nameOrg}/Workspace?redirect=vr`;
}